// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2BEKE","label":"CategoryService_label__3CxBf","location":"CategoryService_location__lkdDd"};